import {LookupTableBaseModel} from '../models/lookup-table-base-model';
import {useLanguageIndependentData} from './useLanguageIndependentData.hook';

export const useCategories =
    useLanguageIndependentData<LookupTableBaseModel[]>('categories');

